export default function urlContain(url) {
    let KEYWORD =  "usedtractorstorage";
    let SAS_TOKEN = "?sv=2021-12-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2026-04-01T14:30:38Z&st=2023-03-29T06:30:38Z&spr=https&sig=mk0i2ZPyaotRM5smvwnf9y9%2BcZljr9BrtLIK2%2FnnJ6k%3D";
    return ( 
    (url?.indexOf(KEYWORD) !== -1) ? `${url}${SAS_TOKEN}` : url
    )
}   